var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"d-flex align-items-center justify-content-between"},[_c('h1',{staticClass:"mb-2 title"},[_vm._t("default",[_vm._v(_vm._s(_vm.title))])],2)]),_c('hr',{staticClass:"my-0"})])}
var staticRenderFns = []

export { render, staticRenderFns }